import { useRef, useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import EventEmitter, {
  SHOW_ORDER_BUSINESS_CREDIT_REPORT,
} from '../../../../helpers/EventEmitter'
import { formatText } from '../../../../helpers/value'
import { BuyPackage } from '../../../buyPackage'
import useCompanyHeader from '../../../category/useCompanyHeader'
import { Element } from '../../../html/element'
import { ButtonCheckoutCustom } from '../../buttonCheckoutCustom'
import { BUTTON_TYPES } from '../../buttonCheckoutCustom/constants'
import { AddToCart } from '../../cart'
import { PopupCheckDataAvailability } from '../../popup/popupCheckDataAvailability'
import { ReportPrice } from '../../reportPrice'
import { CreatedDate } from './CreatedDate'
import { DeliveryDays } from './DeliveryDays'
import classes from './index.module.scss'

export const ReportItem = ({ data }) => {
  const location = useLocation()
  const buyPackageSpanRef = useRef()

  const { companyHeader } = useCompanyHeader({ disableCallApi: true })
  const [isOpenPopupCheckData, setIsOpenPopupCheckData] = useState(false)
  const { organizationId } = new Proxy(new URLSearchParams(location.search), {
    get: (searchParam, prop) => searchParam.get(prop),
  })
  const [buyPackageSpanWidth, setBuyPackageSpanWidth] = useState(0)

  const onOpenPopupCheckData = () => {
    setIsOpenPopupCheckData(true)
  }

  const onClosePopupCheckData = () => {
    setIsOpenPopupCheckData(false)
  }

  return (
    <div className="w100">
      <div className={'flexColumn gap1'}>
        <div>
          {data.isReadyToUseVersion ? (
            <Translate
              value={'common.order.businessCreditReport.READY_TO_USE_VERSION'}
              className="fw600"
            />
          ) : (
            <>
              <Translate
                value={'common.order.businessCreditReport.ON_REQUEST_VERSION'}
                className="fw600"
              />
              &nbsp;
              <DeliveryDays deliveryDays={data.deliveryDays} />
            </>
          )}
        </div>

        {data.hasReadyVersion ? (
          <>
            {data.isReadyToUseVersion ? (
              <div>
                <Translate value="common.order.businessCreditReport.REPORTING_YEAR" />
                <span>: {formatText(data.yearReport)}</span>
              </div>
            ) : (
              <div>
                <Translate value="common.order.businessCreditReport.AVAILABLE" />
                <span>: {formatText(data.availableData)}</span>
              </div>
            )}

            {data.isReadyToUseVersion ? (
              <CreatedDate createdDate={data.createdDate} />
            ) : (
              <div>
                <Element
                  elementName="span"
                  style={{ color: '#2C73E8' }}
                  className="cursorPointer"
                  onClick={onOpenPopupCheckData}
                >
                  <Translate value="common.order.businessCreditReport.CHECK_DATA_AVAILABILITY" />
                </Element>
              </div>
            )}

            <div style={{ width: buyPackageSpanWidth }}>
              <ReportPrice data={data} />
            </div>
            <BuyPackage
              fiinGateReportTypeId={data.id}
              buyPackageSpanRef={buyPackageSpanRef}
              setBuyPackageSpanWidth={setBuyPackageSpanWidth}
            />
          </>
        ) : (
          <div>
            <Translate value="common.order.businessCreditReport.UNAVAILABLE" />
          </div>
        )}
      </div>

      <div className="dFlex mt1">
        <AddToCart
          isFactSheet={false}
          reportName={data.name}
          data={
            data.isReadyToUseVersion
              ? [
                  {
                    fiinGateReportTypeId: data.id,
                    organizationId,
                    companyName: companyHeader.organizationName,
                    taxCode: companyHeader.taxCode,
                    readyVersion: true,
                    readyVersionReportingYear: data.yearReport,
                    readyVersionCreateDate: data.createdDate,
                  },
                ]
              : [
                  {
                    fiinGateReportTypeId: data.id,
                    organizationId,
                    companyName: companyHeader.organizationName,
                    taxCode: companyHeader.taxCode,
                    availableData: data.availableData,
                  },
                ]
          }
        >
          {(handleAddToCart) => (
            <>
              <ButtonCheckoutCustom
                type={BUTTON_TYPES.ADD_TO_CART}
                className={classes.reportItemButton}
                disable={!data.hasReadyVersion}
                onClick={() => {
                  EventEmitter.dispatch(
                    SHOW_ORDER_BUSINESS_CREDIT_REPORT,
                    false,
                  )
                  handleAddToCart(true)
                }}
              />
              <ButtonCheckoutCustom
                type={BUTTON_TYPES.BUY_NOW}
                className={classes.reportItemButton}
                disable={!data.hasReadyVersion}
                onClick={() => {
                  EventEmitter.dispatch(
                    SHOW_ORDER_BUSINESS_CREDIT_REPORT,
                    false,
                  )
                  handleAddToCart()
                }}
              />
            </>
          )}
        </AddToCart>
      </div>

      <PopupCheckDataAvailability
        isOpen={isOpenPopupCheckData}
        onClose={onClosePopupCheckData}
        idReport={data?.id}
      />
    </div>
  )
}
